import { render, staticRenderFns } from "./SensorData.vue?vue&type=template&id=3d36e564&scoped=true&"
import script from "./SensorData.vue?vue&type=script&lang=js&"
export * from "./SensorData.vue?vue&type=script&lang=js&"
import style0 from "./SensorData.vue?vue&type=style&index=0&id=3d36e564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d36e564",
  null
  
)

export default component.exports